import { ArrowBack, GcpBox, GcpTypography } from '@back-office/ui';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface RecurringActionProps {
  shownRejectBtn: boolean;
  showApproveBtn: boolean;
  showCancelBtn: boolean;
  fullName: string;
  onReject: () => void;
  onApprove: () => void;
  onCancel: () => void;
  handleOnClickBreadcrumbs: () => void;
}
const useStyles = makeStyles(
  (theme) => ({
    subLink: {
      cursor: 'pointer',
      fontSize: '14px',
      color: theme.palette.common.silver,
      '&:hover': {
        textDecoration: 'none',
      },
    },
    button: {
      boxShadow: 'none',
      borderRadius: '2px',
      '&:hover': {
        boxShadow: 'none',
      },
    },
    cancel: {
      backgroundColor: 'white',
      border: '1px solid #00000040 !important',
      '&:hover': {
        backgroundColor: 'white',
      },
    },
  }),
  { name: 'TransactionBreadcrumbs' }
);

const RecurringAction: FC<RecurringActionProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const {
    shownRejectBtn,
    showApproveBtn,
    showCancelBtn,
    fullName,
    onReject,
    onApprove,
    onCancel,
    handleOnClickBreadcrumbs,
  } = props;

  return (
    <GcpBox alignItems="center" display="flex">
      <Grid xs={6}>
        <GcpBox alignItems="center" display="flex" gap={1} mb={1}>
          <ArrowBack />
          <Link
            className={classes.subLink}
            color="inherit"
            onClick={handleOnClickBreadcrumbs}
          >
            {t('recurring_payment_detail.title')}
          </Link>
        </GcpBox>
        <GcpTypography variant="h2">{fullName || '-'}</GcpTypography>
      </Grid>

      <Grid xs={6}>
        <GcpBox display="flex" justifyContent="flex-end" pt={2}>
          {shownRejectBtn}
          <GcpBox alignItems="center" display="flex" gap={2} mb={1}>
            {shownRejectBtn && (
              <Button
                className={clsx(classes.button, classes.cancel)}
                variant="contained"
                onClick={onReject}
              >
                {t('recurring_payment_detail.reject')}
              </Button>
            )}
            {showApproveBtn && (
              <Button
                className={classes.button}
                color="primary"
                variant="contained"
                onClick={onApprove}
              >
                {t('recurring_payment_detail.approve')}
              </Button>
            )}
          </GcpBox>

          {showCancelBtn && (
            <Button
              className={classes.button}
              color="primary"
              variant="contained"
              onClick={onCancel}
            >
              {t('recurring_payment_detail.cancel')}
            </Button>
          )}
        </GcpBox>
      </Grid>
    </GcpBox>
  );
};

export default RecurringAction;
